import { render, staticRenderFns } from "./Products-list.vue?vue&type=template&id=1cf36bcc&scoped=true"
import script from "./Products-list.vue?vue&type=script&lang=js"
export * from "./Products-list.vue?vue&type=script&lang=js"
import style0 from "./Products-list.vue?vue&type=style&index=0&id=1cf36bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf36bcc",
  null
  
)

export default component.exports